import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useCallback } from 'react';
import { Slider as MuiSlider } from '@material-ui/core';
import { useBiAction } from '../BiTracking';
export const Slider = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { bi, noBi: _noBi, testId, onChangeCommitted } = props, rest = _object_without_properties(props, [
        "bi",
        "noBi",
        "testId",
        "onChangeCommitted"
    ]);
    const logBiAction = useBiAction();
    const handleChangeCommitted = useCallback((event, value)=>{
        if (bi === null || bi === void 0 ? void 0 : bi.name) {
            logBiAction({
                entityType: 'slider',
                entityName: bi.name,
                actionType: 'select',
                data: _object_spread_props(_object_spread({}, bi.data), {
                    test_id: testId !== null && testId !== void 0 ? testId : '',
                    selected_value: String(value)
                })
            });
        }
        onChangeCommitted === null || onChangeCommitted === void 0 ? void 0 : onChangeCommitted(event, value);
    }, [
        bi,
        logBiAction,
        testId,
        onChangeCommitted
    ]);
    return /*#__PURE__*/ _jsx(MuiSlider, _object_spread_props(_object_spread({}, rest), {
        ref: ref,
        onChangeCommitted: handleChangeCommitted,
        "data-testid": testId
    }));
});
